import React from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';

interface Props {
  data: any;
  phoneWidth: number;
}

const Focus: React.FC<Props> = ({ data }) => {
  return (
    <Box
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      transition="150ms ease"
      position="relative"
      p={1}
      margin="5px 0 5px 0"
    >
      <>
        <Flex direction="column" textAlign="center">
          <Text fontWeight="bold" fontSize="2xl" color="blackAlpha.800">
            {data.name}
          </Text>
        </Flex>
      </>
    </Box>
  );
};

export default Focus;
